import { API_DATA_FORMAT } from 'core-lib/constants/network';
import ip from 'icepick';
import { StoreType } from '../types/product';
import Store from '../types/store';
import {
  UPDATE_CART,
  UPDATE_DELIVERY_ADDRESS,
  UPDATE_STORE_HOME_PAGE,
  UPDATE_ML_EXCLUSIVE_PAGE,
  UPDATE_LISTING,
  UPDATE_LISTING_FILTER_SUBCATEGORY,
  UPDATE_PDP,
  UPDATE_SORT_AND_FILTERS,
  CATEGORY_LISTING,
  CATEGORY_DESCRIPTION,
} from './type';

const initData = {
  ...API_DATA_FORMAT,
  data: [],
};

const listingChildData = {
  currentParentCategoryId: '',
  items: {},
};

const homePageData = {
  ...API_DATA_FORMAT,
  data: [],
  page: 1,
  hasMore: true,
};

const categoryPageData = {
  ...API_DATA_FORMAT,
  data: [],
  page: 1,
  hasMore: true,
};

const categoryDescription = {
  ...API_DATA_FORMAT,
  data: [],
  page: 1,
  hasMore: true,
  categoryName : ""
}



// @TODO: add initialState type
const initialState: Store = ip.freeze({
  storeHomepage: { ...homePageData },
  mlExclusivepage: { ...homePageData },
  categoryListing : {...categoryPageData},
  categoryDescription: {...categoryDescription},
  cart: { ...API_DATA_FORMAT },
  listing: {
    ...API_DATA_FORMAT,
    data: {
      products: [],
      storeType: StoreType.ParkplusStore,
      nextPage: 1,
      hasMore: false,
      totalCount: 0,
      currentFilter: '',
    },
  },
  deliveryAddress: { ...API_DATA_FORMAT, selectedAddress: null },
  listingFilterSubcategory: {
    ...API_DATA_FORMAT,
    data: { ...listingChildData },
  },
  sortAndFilters: {
    ...API_DATA_FORMAT,
    data: { ...listingChildData },
  },
  productDescriptions: {
    ...API_DATA_FORMAT,
    data: {},
  },
});

const ParkplusStoreV2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STORE_HOME_PAGE: {
      if (action.payload) {
        state = ip.setIn(state, ['storeHomepage'], action.payload);
      }
      return state;
    }

    case UPDATE_ML_EXCLUSIVE_PAGE: {
      if (action.payload) {
        state = ip.setIn(state, ['mlExclusivepage'], action.payload);
      }
      return state;
    }

    case UPDATE_CART: {
      if (action.payload) {
        state = ip.setIn(state, ['cart'], action.payload);
      }
      return state;
    }

    case UPDATE_LISTING: {
      if (action.payload) {
        state = ip.setIn(state, ['listing'], action.payload);
      }
      return state;
    }

    case UPDATE_DELIVERY_ADDRESS: {
      if (action.payload) {
        state = ip.setIn(state, ['deliveryAddress'], action.payload);
      }
      return state;
    }

    case UPDATE_LISTING_FILTER_SUBCATEGORY: {
      if (action.payload) {
        state = ip.setIn(state, ['listingFilterSubcategory'], action.payload);
      }
      return state;
    }

    case UPDATE_SORT_AND_FILTERS: {
      if (action.payload) {
        state = ip.setIn(state, ['sortAndFilters'], action.payload);
      }
      return state;
    }

    case UPDATE_PDP: {
      if (action.payload) {
        state = ip.setIn(state, ['productDescriptions'], action.payload);
      }
      return state;
    }

    case CATEGORY_LISTING :{
      if(action.payload){
        state = ip.setIn(state, ['categoryListing'], action.payload);
      }
    }

    case CATEGORY_DESCRIPTION :{
      if(action.payload){
        state = ip.setIn(state, ['categoryDescription'], action.payload);
      }
    }

    default: {
      return state;
    }
  }
};

export default ParkplusStoreV2Reducer;
